import Vue from "vue";
import VueRouter from "vue-router";

import routes from "./routes";
import store from "@/store";

import PermissionCheck from "@/mixins/PermissionCheck";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active",
  mode: "history"
});

router.beforeEach((to, from, next) => {
  const guestAccess = to.matched.some(record => record.meta.guestAccess);
  const loggedIn = store.getters.isAuthenticated;

  if (!guestAccess && !loggedIn) {
    return next("/login");
  } else {
    if (to.meta.permissions && to.meta.permissions.length > 0) {
      let roles = ["admin", "super-admin"];
      let isAllowed = PermissionCheck.methods.$allowed(
        to.meta.permissions,
        roles
      );

      if (!isAllowed) return next("/unauthorised");
    }

    next();
  }

  // } else if (Array.isArray(permissions) && permissions.length > 0) {
  //   console.log(permissions)
  //   console.log(store.state.security)
  //   return next();
  //   // check permissions

  // } else {
  //   return next();
  // }
});

export default router;
